<template>
    <section>
        <el-row  v-show="masterVisable"  :gutter="40">
            <el-col :span="spanLeft">
                <el-tag type="gray" style="margin: 10px">部门</el-tag>
                <el-button v-if="isAdmin" type="primary" size="small" @click="handleAdd">新增</el-button>
                <el-tree
                        ref="productType"
                        v-loading="treeLoading"
                        :data="data2"
                        :props="defaultProps"
                        node-key="FID"
                        @current-change="onDeptChange"
                        highlight-current
                        :expand-on-click-node="true"
                        :default-expanded-keys="expandedkeys"
                        @node-expand="nodeexpand"
                        @node-collapse="nodecollapse"
                        :render-content="renderContent">
                </el-tree>
            </el-col>
            <el-col :span="24-spanLeft">
                <Staff  @onPackUp="onPackUp" ref="emp" @onviewchart="viewChart"></Staff>
            </el-col>
        </el-row>

    

        <el-dialog :title="tit" v-model="treeFormVisible" :visible.sync="treeFormVisible" :close-on-click-modal="false">
            <el-form :model="treeForm"  label-width="110px">
                <el-form-item label="名称">
                    <el-input v-model="treeForm.FName"></el-input>
                </el-form-item>
                <el-form-item label="负责人">
                    <el-input v-model="treeForm.FLeader"></el-input>
                </el-form-item>
                <el-form-item label="顺序">
                    <el-input v-model="treeForm.FSort"></el-input>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input type="textarea" v-model="treeForm.FNote"></el-input>
                </el-form-item>
                <!-- <el-form-item label="类型" prop="FType">
                    <el-select v-model="treeForm.FType"  placeholder="请选择">
                        <el-option label="机构" value="机构"></el-option>
                        <el-option label="部门" value="部门"></el-option>
                        <el-option label="管理员" value="管理员"></el-option>
                        <el-option label="其它" value="其它"></el-option>
                    </el-select>
                </el-form-item> -->
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="treeFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveTree" :loading="formLoading">保存</el-button>
            </div>
        </el-dialog>
    </section>
</template>

<script>
    import util from '../../common/util'
    import Staff from "../business/Staff.vue"
    export default {
        components:{
            Staff
        },
        data(){
            return {
                isAdmin:global.user.FID==-1,
                masterVisable:true,
                chartVisable:false,
                FDeptID:0,
                data2: [],
                selectNodeData:{},
                defaultProps: {
                    children: 'children',
                    label: 'FName'
                },
                treeForm:{},
                treeFormVisible:false,
                treeLoading:false,
                formLoading:false,
                tit:'',
                expandedkeys:[],
                expandedkeysparents:[],
                removeids:[],
                spanLeft:8
            }
        },
        methods:{
            onPackUp(flag){
                if (this.spanLeft == 8) {
                     this.spanLeft = 0
                }else{
                    this.spanLeft = 8
                }
            },
            viewChart(row){
                this.masterVisable = false
                this.chartVisable = true
                this.$refs.chart._init(row.FID,row.FName)
            },
            back(){
                this.masterVisable = true
                this.chartVisable = false
            },
            onDeptChange(row,oldRow){
                if(row) {
                    this.FDeptID = row.FID
                    this.$refs.emp._search(row)
                }
            },
            ////////////////////////用户//////////////////////////////////
            beforeAddUser(row,r){
                if(this.FDeptID==0) {
                    return r.error = "请先选择团队";
                }
                row.FDeptID = this.FDeptID
            },
            switchLoading(flag){
                this.treeLoading = flag;
            },
            handleAdd:function(){
                this.treeFormVisible = true
                this.selectNodeData = null;
                this.treeForm = {id:0,FID:0,FParent:0,FVisable_Vue:true,FLevel:1,FType:"",
                    FUrl_Vue:"/",FRequire_Vue:"Home.vue",FIconCls_Vue:"el-icon-message"}
                this.store = null;
                this.tit='新增';
            },
            saveTree(){
                util.post("server/system/Dept.ashx?cmd=Save",this.treeForm,this.switchFormLoading,result=> {
                    util.msgSuc("保存成功")
                    this.expandedkeys.push(result.FID)
                    this.expandedkeysparents.push(this.treeForm.FParent)
                    this.treeFormVisible = false
                    if(this.treeForm.FID==0){
                        this.treeForm.FID = result.FID
                        if(this.store) {
                            this.refrash()
                        }else{
                            //刷新
                            this.refrash()
                        }
                    }else{
                        if(this.selectNodeData) {
                            this.refrash()

                        }else{
                            this.refrash()
                        }
                    }
                })
            },
            append(store, data,node) {
                this.treeFormVisible = true
                this.selectNodeData = data;
                this.treeForm = {id:0,FID:0,FParentID:data.FID,FType:""};
                //如果是权限项
                // if(data.FUrl_Vue=="/"){
                //     this.treeForm.FLevel = 2
                //  }else{
                //      this.treeForm.FUrl_Vue ="#"
                //     this.treeForm.FLevel = 3
                // }
                this.store = store;
                this.tit='新增子部门';
                //store.append({ id: 1000, label: 'testtest', children: [] }, data);
            },
            edit(store, data,node) {
                debugger
                this.treeFormVisible = true
                this.selectNodeData = data
                if(!data.FType) data.FType=""
                this.treeForm = Object.assign({},data)
                this.store = store;
                this.tit='修改';
                //store.append({ id: 1000, label: 'testtest', children: [] }, data);
            },
            remove(store, data,node) {
                // TO-DO: 需要提示是否删除
                if(data.FID<0){
                     util.msgWarning("系统内置不可删除")
                     return
                }
                this.$confirm('删除后不可恢复，确认删除吗?', '提示', {
                    //type: 'warning'
                }).then(()=>{
                    let url = "server/system/Dept.ashx?cmd=Delete"
                    util.post(url, {FID:data.FID},this.switchLoading,result=> {
                        util.msgSuc("删除成功")
                        store.remove(data);
                        var removeindex = this.expandedkeys.indexOf(data.FID);
                        if (removeindex > -1) {
                            this.expandedkeys.splice(removeindex, 1);
                            this.expandedkeysparents.splice(removeindex, 1);
                        }
                    })
                });
            },
            renderContent(h, { node, data, store }) {
                return (
                    <span style="width:100%;">
                    <span>
                    <span>{node.label}</span>
                </span>
                <span style="float: right; margin-right: 20px">
                <el-button size="mini" class="el-icon-edit el-button el-button--text el-button--mini" on-click={ () =>{this.edit(store, data,node);event.stopPropagation()} }> 修改</el-button>
                <el-button size="mini" class="el-icon-delete el-button el-button--text el-button--mini" type="danger" on-click={ () => {this.remove(store, data,node);event.stopPropagation()} }> 删除</el-button>
                </span>
                </span>);
            },
            refrash(){
                util.get("server/system/Dept.ashx?cmd=GetDeptTree","",this.switchLoading,result=> {
                    this.data2 = result.data;
                    //默认展开自己的阶段
                    this.expandedkeys = [global.user.FDeptID]
                });
            },
            nodeexpand(data){
                this.expandedkeys.push(data.FID);
                this.expandedkeysparents.push(data.FParentID)
            },
            nodecollapse(data){
                var index = this.expandedkeys.indexOf(data.FID);
                if (index > -1) {
                    // this.expandedkeys.splice(index, 1);
                    this.removeids.push(this.expandedkeys[index])
                    this.getremoveid(this.expandedkeys[index])
                    for(var i=0 ;i<this.removeids.length;i++){
                        var removeindex = this.expandedkeys.indexOf(this.removeids[i]);
                        if (removeindex > -1) {
                            this.expandedkeys.splice(removeindex, 1);
                            this.expandedkeysparents.splice(removeindex, 1);
                        }
                    }
                }
            },
            getremoveid(parentid){
                for(var i=0 ;i<this.expandedkeysparents.length;i++){
                    if(this.expandedkeysparents[i]==parentid){
                        this.removeids.push(this.expandedkeys[i])
                        this.getremoveid(this.expandedkeys[i])
                    }
                }
            }
        },
        mounted() {
            this.refrash()
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/system/Dept.vue